<script setup lang="ts">
import * as Sentry from "@sentry/vue";

// const props = defineProps<{
//   assistantId: string;
// }>();

interface Theme {
  [name: string]: string;
}

const { fetchData } = useApi();

const loadingComplete = ref(false);

const loadFonts = () => {
  let linkNode;

  // Material icons
  linkNode = document.createElement("link");
  linkNode.type = "text/css";
  linkNode.rel = "stylesheet";
  linkNode.href = "https://fonts.googleapis.com/icon?family=Material+Icons";
  document.head.appendChild(linkNode);

  // Manrope
  linkNode = document.createElement("link");
  linkNode.type = "text/css";
  linkNode.rel = "stylesheet";
  linkNode.href =
    "https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap";
  document.head.appendChild(linkNode);
};

const fetchAssistantSettingsData = async () => {
  const assistantSettingsStore = useAssistantSettingsStore();
  try {
    const response = await fetchData("/assistant-settings");
    assistantSettingsStore.assistantSettings = response.data;
    applyAssistantTheme(response.data.theme);
  } catch (e: unknown) {
    const error = useApiError(e);
    // We don't need to send validation errors to sentry
    if (!error.isValidationError) {
      Sentry.captureException(e);
    }
    throw e;
  }
};

const applyAssistantTheme = (theme: Theme) => {
  if (theme) {
    Object.keys(theme).forEach((key) => {
      const cssVariable = `--${snakeToKebab(key)}`;
      document.documentElement.style.setProperty(cssVariable, theme![key]);
    });
  }
};

const init = async () => {
  loadFonts();
  await fetchAssistantSettingsData();
  loadingComplete.value = true;
};

init();
</script>

<template>
  <!-- <link
    type="text/css"
    rel="stylesheet"
    href="http://wijsneus-widget-website.test/widget.css"
  /> -->

  <WidgetLayout v-if="loadingComplete">
    <LayoutHeader />
    <ChatWindow />
  </WidgetLayout>
</template>

<style lang="scss">
:host {
  // Fonts
  font-family: "Manrope", serif;
}

p {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: underline;
}
</style>
